// extracted by mini-css-extract-plugin
module.exports = {"root":"_28DJQf","item":"_2TKnxz","itemToBottom":"_2MKODf","itemSpaceBefore":"_4V5P-F","link":"blQ2qR","linkLg":"_13qF4K","text":"_1DV0Rn"};